<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <v-card>
      <v-card-title>
        {{ $t('accounts.accSuspended') }}
      </v-card-title>
      <v-card-text>
        {{ $t('accounts.accSuspendedDesc') }}
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          text
          @click="go()"
        >
          {{ $t('invoices.viewInvoices') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'HelperSuspended',
  data: () => ({
    dialog: false
  }),
  methods: {
    open() {
      this.dialog = true;
    },
    go() {
      this.dialog = false
      this.$router.push('/invoices')
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
